import React, { useState, useEffect, useRef } from 'react'
import './styles.scss'
import Heading from '../heading/Heading'
import LeasingRateBox from '../leasing-rate-box/LeasingRateBox';
import { useSelector, useDispatch } from 'react-redux'
import phoneIco from './../../images/phone-ico.svg'
import checkNaN from '../../services/checkNaN';
import formatPrice from '../../services/formatPrice';
import LeasingRateBoxResult from '../leasing-rate-box/LeasingRateBoxResult';
import Checkbox from './../form/checkbox/Checkbox';
import Button from './../buttons/Button';
import Text from './../text/Text';
import DrawDocuSign from '../../services/DrawDocuSign';

const LeasingRateResult = ( props ) => {
    let callNumber = useSelector(state => state.callNumber);
    let tax = useSelector(state => state.tax); 
    let productPriceEnd = useSelector(state => state.productPriceEnd); 
    let productPrice = useSelector(state => state.productPrice); 
    let activeContract = useSelector(state => state.selectedLease); 
    let isShop = useSelector(state => state.isShop); 
    let leasingTime = useSelector(state => state.leasingTime)
    let rate = useSelector(state => state.rate);
    let rateFrequency = useSelector(state => state.rateFrequency);
    let data = window.AppConfig ? window.AppConfig.modalAxaText : null;
    let chargePrice     = useSelector(state => state.chargePrice)
    let [ checkbox, setCheckbox ] = useState(false);
    let disclaimerReg = useSelector(state => state.disclaimerReg);
    const iframeRef = useRef(null);

    let companyName = useSelector(state => state.companyName);
    let legalRepresentative = useSelector(state => state.legalRepresentative);
    let companyAddress = useSelector(state => state.companyAddress);
    let phone = useSelector(state => state.phone);
    let email = useSelector(state => state.email);
    let trn = useSelector(state => state.trn);
    let shareCapital = useSelector(state => state.shareCapital);
    let legalForm = useSelector(state => state.legalForm);
    let lineBusiness = useSelector(state => state.lineBusiness);
    let revenueLastFinancialYear = useSelector(state => state.revenueLastFinancialYear);
    let revenuePresentFinancialYear = useSelector(state => state.revenuePresentFinancialYear);
    let employeesNumber = useSelector(state => state.employeesNumber)
    let financialAddress = useSelector(state => state.financialAddress);
    let bankName = useSelector(state => state.bankName);
    let bankIban = useSelector(state => state.bankIban);
    let bankEmail = useSelector(state => state.bankEmail);
    let signedFileUrl = useSelector(state => state.signedFileUrl);
    let authorizedPersons      = useSelector(state => state.authorizedPersons)
    const [file, setFile] = useState(null);
    const [signUrl, setSignUrl] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);

    const dispatch = useDispatch()

    useEffect(() => {
        if(signedFileUrl) {
            console.log(signedFileUrl)
            console.log('ok')
            if (iframeRef.current) {
                console.log('300px')
                iframeRef.current.style.height = '300px'; // dowolna wysokość
            }
        }
    }, [signedFileUrl])

    const handleSubmit = async (e) => {
        if (!file) return;
        let person = authorizedPersons[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('email', person.email);
        formData.append('name', `${person.name} ${person.surname}`);

        const res = await fetch('https://calculator.grenke-dubaj.s5.norddigital.pl:5000/api/send-document', {
            method: 'POST',
            body: formData
        });

        const data = await res.json();
        console.log(data.url);
        setSignUrl(data.url.viewUrl);  // Otrzymany URL dokumentu
        setFileUrl(data.url.fileUrl);
        // dispatch( {type: 'SIGNED_FILE_URL', value: data.url.signedUrl } ) 
    };
    return (
        <>
        <div className="result-leasing-rate">
            <div className={"leasing-rate " + (isShop ? 'shop' : '') }>
                <div className="wrap">
                    <div className="shadow-box">
                        <Heading title={ "Leasing instalment calculation" }
                            tip={ false } 
                            tipHeader="Leasing instalment calculation"
                            tipText={ `The Initial Term set out above shall commence on the first day of the Gregorian calendar quarter (i. e. 01 January, 01 April, 01 July, 01 October) following the date of delivery of the Leased Object(s) set out above in case, the Lessee has to pay the Leasing Fee as set out above quarterly in advance and shall commence on the first day of the next calendar month in case, the Lessee has to pay the Leasing Fee on a monthly basis (“Commencement Date”). The Lessee has to pay 1/30 (One Thirtieth) of the monthly Leasing Fee for each day of the interim period between delivery of the Leased Object(s) and Commencement Date. This interim period is subject to the conditions of this Classic Lease Contract (“Contract”), as defined in the “General Terms and Conditions of Lease” (“GTC”) and the GTC.` } />
                        <div className="values">
                            <div className="value">
                                <p><strong>Items value</strong></p>
                                <p>
                                    <strong>{ checkNaN(formatPrice(productPrice)) }</strong>
                                </p>
                            </div>
                            <div className="value">
                                <p>Administration fee</p>
                                <p>{ tax }</p>
                            </div>
                            <div className="value">
                                <p>Initial term</p>
                                <p>{ leasingTime } months</p>
                            </div>
                        </div>
                        <LeasingRateBoxResult 
                            text="The above amounts are subject to VAT. This calculation is for informational purposes only and does not constitute an offer within the meaning of the Civil Code.</br></br>The Initial Term set out above shall commence on the first day of the Gregorian calendar uarter (i. e.01 January, 01 April, 01 July, 01 October) following the date of delivery of the Leased Object(s) set out above in case, the Lessee has to pay the Leasing Fee as set out above quarterly in advance and shall commence on the first day of the next calendar month in case, the Lessee has to pay the Leasing Fee on a monthly basis (“Commencement Date”). The Lessee has to pay 1/30 (One Thirtieth) of the monthly Leasing Fee for each day of the interim period between delivery of the Leased Object(s) and Commencement Date. This interim period is subject to the conditions of this Classic Lease Contract (“Contract”), as defined in the “General Terms and Conditions of Lease” (“GTC”) and the GTC" 
                        />
                        {/* <div className="texta">
                            {activeContract == 'tradycyjny' &&
                                <>
                                { rateFrequency == 'miesięcznie' &&
                                    <p>Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty.</p>
                                }

                                {rateFrequency == 'kwartalnie' && 
                                    <p>Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego kwartału następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/90 raty.</p>
                                }
                                </>
                            }
                            {activeContract == 'nowoczesny' &&
                                <>
                                { rateFrequency == 'miesięcznie' &&
                                    <p>Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty.</p>
                                }

                                {rateFrequency == 'kwartalnie' && 
                                    <p>Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego kwartału następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/90 raty.</p>
                                }
                                </>
                            }
                        </div> */}
                    </div>
                </div>
                <Heading title="Disclaimer" 
                        medium
                        moreMarginTop
                        class=""
                        tip={ true } 
                        tipHeader="Liczba pracowników"
                        tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                <Checkbox   required={ true } 
                            id="disclaimer-checkbox"
                            setFunction={ (val) => dispatch({ type: 'DISCLAIMER_REG_CHANGE', value: val }) }
                            val={ disclaimerReg }
                            forceValidate={ props.forceValidate }
                            text="We, the undersigned entity, including but not limited to mainland companies, free zone companies, offshore companies, limited liability companies, public and private joint stock companies, partnerships and sole proprietorships hereby confirm that all the information provided in this self-disclosure form, including corporate, financial, and other relevant details, is accurate, true, and complete to the best of our knowledge. We understand that any false or misleading information may result in legal consequences in accordance with the applicable laws and regulations of the United Arab Emirates. We undertake to fully indemnify and to keep GC Leasing Middle East FZCO and its Branches (individually and collectively referred to as “grenke”) harmless with regard to any loss or damage (including, without limitation legal expenses incurred) arising from misleading." />
            </div>
        </div>
        {authorizedPersons && authorizedPersons[0] && authorizedPersons[0].name &&
        <div className="docu-sign-wrapper">
            <Button title="Sign the Disclousure with Docu sign" class={`black reverse`} add={ true } setFunction={ (e) => handleSubmit(e) } />
            <Text text={`Info about login`} />

            <DrawDocuSign 
                setFile={(file) => setFile(file)} 
                companyName={companyName && companyName.length > 0 ? companyName : "?"} 
                legalRepresentative={legalRepresentative && legalRepresentative.length > 0 ? legalRepresentative : "?"} 
                companyAddress={companyAddress && companyAddress.length > 0 ? companyAddress : "?"} 
                phone={phone && phone.length > 0 ? phone : "?"} 
                email={email && email.length > 0 ? email : "?"} 
                trn={trn && trn.length > 0 ? trn : "?"} 
                shareCapital={shareCapital && shareCapital.length > 0 ? shareCapital : "?"} 
                legalForm={legalForm && legalForm.length > 0 ? legalForm : "?"}
                lineBusiness={lineBusiness && lineBusiness.length > 0 ? lineBusiness : "?"}
                revenueLastFinancialYear={revenueLastFinancialYear && revenueLastFinancialYear.length > 0 ? revenueLastFinancialYear : "?"}
                revenuePresentFinancialYear={revenuePresentFinancialYear && revenuePresentFinancialYear.length > 0 ? revenuePresentFinancialYear : "?"}
                employeesNumber={employeesNumber && employeesNumber.length > 0 ? employeesNumber : "?"}
                financialAddress={financialAddress && financialAddress.length > 0 ? financialAddress : "?"} 
                bankName={bankName && bankName.length > 0 ? bankName : "?"} 
                bankIban={bankIban && bankIban.length > 0 ? bankIban : "?"}
                bankEmail={bankEmail && bankEmail.length > 0 ? bankEmail : "?"}  
                bankNumber={"?"} />

            {signUrl && (
                <iframe ref={iframeRef} title="DocuSign" src={signUrl} width="100%" height="800" />
            )}
        </div>
        }
        </>
    )
}

export default LeasingRateResult;